export default {
  // Sidebar Navigation
  sidebar: {
    dashboard: "Painel",
    plans: "Planos",
    organizationDesign: "Design da Organização",
    evaluation: "Avaliação",
    talentPool: "Pool de Talentos",
    reports: "Relatórios",
    notifications: "Notificações",
    switchOrg: "Mudar Organização"
  },
  // Talent Pool / Users Page
  talentPool: {
    relationshipAddedSuccessfully: "Relacionamento adicionado com sucesso",
    relationshipRemovedSuccessfully: "Relacionamento removido com sucesso",
    relationshipSavedSuccessfully: "Relacionamento Salvo com Sucesso",
    profileCard: "Cartão de Perfil",
    viewOptions: {
      plan: "Plano",
      hierarchy: "Hierarquia",
      network: "Rede"
    },
    searchPlaceholder: "Pesquisar usuários...",
    networkSearchPlaceholder: "Pesquisar rede...",
    hierarchySearchPlaceholder: "Pesquisar hierarquia...",
    // KVDR Notifications
    kvdrNotifications: {
      create: "Criar",
      roleCreatedSuccessfully: "Função criada com sucesso",
      delete: "Excluir",
      roleDeletedSuccessfully: "Função excluída com sucesso",
      addProfile: "Adicionar Perfil",
      profileAddedSuccessfully: "Perfil adicionado com sucesso",
      removeProfile: "Remover Perfil",
      profileRemovedSuccessfully: "Perfil removido com sucesso",
      roleUpdate: "Atualização de Função",
      updatedSuccessfully: "Atualizado com sucesso",
      profileUpdate: "Atualização de Perfil",
      profileUpdatedSuccessfully: "Perfil atualizado com sucesso"
    },
    title: "Pool de talentos",
    reviewRequest: "Solicitação de revisão",
    // Main talent pool
    noPendingRequest: "Nenhuma solicitação pendente encontrada",
    dropresume: "Solte os currículos para importar",
    processingResume: "Processando currículos...",
    draganddropPopup: "Arraste e largue o seu currículo aqui",
    Clicktoselectfiles: "ou clique para selecionar arquivos",
    Supportedfileformats: "Formatos de arquivo suportados: PDF, DOC, DOCX, TXT.",
    Maxuploadsize: "Máximo 10 arquivos por upload.",
    processingStatus: "Status de processamento",
    importResumes: "Importar currículos",
    downloadResume: "Baixar currículo",
    loading_Resume: "Carregando currículo",
    Resume_Preview: "Visualização de currículo",
    UploadNewResume: "Enviar novo currículo",
    choosefile: "Escolher arquivo",
    AddMembers: "Adicionar membros",
    previewNotAvailable: "Visualização não disponível",
    download: "Baixar",
    roleTitle: "Título da Função",
    firstName: "Primeiro Nome",
    lastName: "Sobrenome",
    email: "E-mail",
    accessLevel: "Nível de acesso",
    AddRelationship: "Adicionar relacionamento",
    RelationshipSavedSuccessfully: "Relacionamento salvo com sucesso",
    RelationshipAddedSuccessfully: "Relacionamento adicionado com sucesso",
    RelationshipRemovedSuccessfully: "Relacionamento removido com sucesso",

    Resume_not_found: "Currículo não encontrado",
    we_could_not_find_resume: "Não conseguimos encontrar um currículo para",
    pleaseSelectFile: "Por favor, selecione um arquivo suportado para enviá-lo agora.",
    verify: "Verificar e enviar",
    uploading: "Enviando...",
    career_objective: "Objetivo Profissional",
    no_objective_provided: "Nenhum objetivo fornecido",
    view_talent_card: "Ver cartão de talento",
    skills: "Habilidades",
    deactivateUserTitle: "Desativar usuário da organização",
    areYouSure: "Tem certeza de que deseja desativar",
    fromThisOrganization: "desta organização?",
    deactivate_user: "Desativar usuário",
    deactivationInProgress: "Desativação em andamento...",
    confirm: "Confirmar",
    noEmailOnRecord: "Nenhum email registrado para este usuário",
    contact_info: "Informações de Contato",
    processingComplete: "Processamento completo",
    uploadingAndParsing: "Enviando e analisando...",
    parsingProfiles: "Analisando perfis...",
    total_progress: "Progresso total",
    Batches_in_queue: "Lotes na fila",
    processed: "processados",
    finish: "Finalizar",
    done: "Concluído",
    failed: "Falhou",
    Uploading_batch: "Enviando lote...",
    Upload_More_Resumes: "Enviar Mais Currículos",
    importFrom: "Importar de",
    uploadExcel: "enviar excel",
    uploadResumes: "enviar currículos",
    uploadResumesTooltip: "Importar desde currículos (PDF)",
    orHRIS: "ou HRIS",
    pendingRequest: "Solicitação pendente",
    allUsers: "Todos os usuários",
    addNewEmployee: "Adicionar novo cartão de funcionário",
    // Table headers
    name: "Nome",
    email: "E-mail",
    maxRole: "Função máxima",
    relationships: "Relacionamentos",
    action: "Ação",
    // User search
    searchUser: "Pesquisar usuário",
    userNotFound: "Usuário não encontrado.",
    // Relationship management
    member: "Membro",
    relationship: "Relacionamento",
    addRelation: "Adicionar relacionamento",
    removeRelationship: "Remover relacionamento"
  },
  // Settings Help Page
  settingsHelp: {
    frequentlyAskedQuestions: "Perguntas Frequentes",
    question1: "Como gerencio as configurações da minha organização?",
    question2: "Como posso convidar novos membros para minha organização?",
    question3: "Quais são os diferentes papéis e permissões de usuário?",
    question4: "Como personalizo a marca da minha organização?",
    helpText: "Este é um texto de ajuda de exemplo. Entre em contato com o suporte para assistência específica com as configurações e configuração da sua organização."
  },
  // Create Organization
  createOrganization: {
    organizationName: "Nome da organização",
    organizationUsername: "Nome de usuário da organização",
    website: "Site",
    workEmail: "Email de trabalho",
    location: "Localização",
    organizationType: "Tipo de organização",
    primaryThemeColor: "Cor do tema principal",
    secondaryThemeColor: "Cor do tema secundário",
    about: "Sobre",
    saveChanges: "Salvar alterações",
    usernameExists: "Este nome de usuário já existe",
    usernameAvailable: "Este nome de usuário está disponível",
    organizationTypeOptions: {
      business: "Negócio",
      academic: "Acadêmico",
      recruiter: "Recrutador"
    },
    logo: {
      adjustTitle: "Ajustar logo da organização",
      save: "Salvar",
      uploadButton: "Enviar logo",
      incorrectFileType: "Tipo de arquivo incorreto",
      incorrectFileTypeText: "Por favor envie um tipo de arquivo de imagem suportado, ex. jpg, png, etc.",
      fileSizeExceeded: "Tamanho do arquivo de imagem excedido",
      fileSizeExceededText: "O tamanho da imagem de perfil deve ser menor que 1MB."
    }
  },

  // Main Organizations List
  main: {
    select: "Selecionar",
    acceptInvitation: "Aceitar convite",
    noOrganizationFound: "Nenhuma organização encontrada!",
    noOrganizationSubtext: "Crie sua própria organização primeiro.",
    createOrganization: "Criar organização"
  },

  // Organization Dashboard
  organization: {
    welcomeBack: "Bem-vindo de volta! 👋",
    setupComplete: "Configuração completa!",
    setupProgress: "Configuração: {step} de 4",
    copyLink: "Copiar link",
    linkCopied: "Link copiado",
    criticalRoles: "Funções críticas",
    talentPool: "Pool de talentos",
    integrations: "Integrações",
    onboarding: "Integração",
    activeCandidates: "Candidatos ativos",
    connectedApps: "Aplicativos conectados",
    pendingOnboards: "Integrações pendentes",
    kvdrReportsCenter: "Centro de relatórios KVDR",
    kvdrReportsDescription: "Mergulhe em seus relatórios de dados visuais chave e obtenha insights críticos.",
    exploreReports: "Explorar relatórios >",
    talentPoolExplorer: "Explorador de pool de talentos",
    talentPoolDescription: "Descubra, analise e gerencie seus melhores talentos com insights abrangentes.",
    exploreTalentPool: "Explorar pool de talentos >",
    thisMonth: "este mês",
    goToOnboarding: "Ir para integração",

    addWebsiteLink: "Adicionar link do website",

    keyRoles: "Funções-chave",
    activePlans: "Planos Ativos",
    completedPlans: "Planos Concluídos",
    viewCandidates: "Ver Candidatos",
    accrossOrganization: "Em Toda a Organização",
    viewBoards: "Ver Quadros",
    archived: "Arquivados / Finalizados",

    topRolesDistribution: "Distribuição das Principais Funções",
    employees: "Colaboradores",
    noData: "Ainda não há dados disponíveis.",

    plansVelocity: "Velocidade dos Planos",
    pv_desc: "Comparação entre planos estratégicos ativos e concluídos.",
    active: "Ativo",
    completed: "Concluído",

    kvdrReports: "Relatórios KVDR",
    kvdrReports_desc: "Gerar insights e descarregar relatórios visuais",
    talentExplorer: "Explorador de Talentos",
    talentExplorer_desc: "Gerir candidatos e colaboradores",

    allSet: "Tudo pronto!",
    stepInProgress: "Etapa em progresso:",
    completeProg: "O perfil da sua organização está 100% completo.",
    incompleteProg: "Está na etapa {onboardingStep} de 4. Complete o seu perfil para desbloquear todas as funcionalidades.",
    continueSetup: "Continuar Configuração",
    viewDetails: "Ver Detalhes",

    onboardingSteps: {
      welcome: "Bem-vindo",
      welcome_desc1: "Vamos configurar o seu pool de talentos para iniciar a sua jornada KVDR e impulsionar a sua estratégia de talento!",
      welcome_desc2: "Siga estes passos para alinhar o talento com o que realmente gera resultados de negócio e construir um ecossistema de talentos baseado em dados.",
      step1_title: "Definir Funções da Organização",
      step1_desc: "Estruture equipas em torno de funções críticas para o valor do negócio.",
      step2_title: "Adicionar Talento",
      step2_desc: "Importe dados de pessoas a partir de qualquer fonte.",
      step3_title: "Avaliar",
      step3_desc: "Configure os seus indicadores para avaliar o talento com base no que mais importa para a sua organização.",
      step4_title: "Planear",
      step4_desc: "Transforme insights em ações de adequação, desenvolvimento e sucessão com um plano de talento para cada função.",
      next: "Seguinte",
      previous: "Anterior",
      done: "Concluído",
      import: "Importar &",
      finish: "Finalizar",

      step1: {
        title: "Estrutura da Organização",
        description: "Inicializámos o espaço de trabalho da sua organização. Clique abaixo para personalizar os seus departamentos, funções e configurações de hierarquia no Planeador de Organização.",
        departments: "Departamentos",
        departments_desc: "Gerir unidades de negócio",
        roles: "Funções",
        roles_desc: "Definir cargos",
        hierarchy: "Hierarquia",
        hierarchy_desc: "Definir linhas de reporte",
        instructions: "Clique em qualquer cartão acima para abrir o Planeador de Organização, ou clique em 'Seguinte' para prosseguir para a Importação.",
      },

      step2: {
        title: "Escolha o seu método de upload",
        title2: "Ficheiros de Currículo",
        description: "Arraste e solte ou clique para procurar",
        instructions: "Formatos suportados: PDF, .txt, .doc, .docx",
      },

      step4: {
        title: "Passo Final:",
        title2: "Está no Passo 4 de 4. Reveja abaixo os seus insights de talento.",
        button: "Finalizar Configuração",
      },
    }
  },

  // Reports
  reports: {
    title: "Relatórios",
    nineCellMatrix: "Matriz de nove células",
    xyPlot: "Gráfico XY",
    talentScoreCard: "Cartão de pontuação de talentos",
    emptyReports: "Relatórios vazios",
    createKVDRFirst: "Crie primeiro um KVDR e planeje para ver relatórios",
    // XY Plot specific
    xAxis: "Eixo X",
    yAxis: "Eixo Y",
    bubbleSize: "Tamanho da bolha",
    loadingChart: "Carregando gráfico...",
    howToReadChart: "Como ler este gráfico",
    positioning: "Posicionamento",
    horizontalPosition: "A posição horizontal mostra",
    verticalPosition: "A posição vertical mostra",
    bubbleRepresentation: "Representação de bolhas",
    eachBubbleRepresents: "Cada bolha representa um funcionário",
    sizeIndicates: "O tamanho indica",
    quadrants: "Quadrantes",
    topLeft: "Superior-Esquerda",
    topRight: "Superior-Direita",
    bottomLeft: "Inferior-Esquerda",
    bottomRight: "Inferior-Direita",
    low: "Baixo",
    high: "Alto",
    interaction: "Interação",
    hoverOverBubble: "Passe o mouse sobre uma bolha",
    revealsDetailedMetrics: "Revela métricas detalhadas para esse funcionário",
    colorCoding: "Codificação de cores",
    differentColorsHelp: "Cores diferentes ajudam a distinguir funcionários",
    // Nine Cell Matrix specific
    nineCellMatrixTitle: "Categorização de funcionários por matriz de nove células",
    methodologyDescription: "Metodologia padronizada baseada em pontuação de desempenho e prontidão para sucessão",
    loading: "Carregando...",
    preparingMatrix: "Preparando a matriz de nove células...",
    noDataAvailable: "Nenhum dado disponível",
    employeeAssessmentRequired: "Dados de avaliação de funcionários são necessários para exibir a matriz de nove células.",
    successionReadiness: "Prontidão para sucessão",
    performanceScore: "Pontuação de desempenho",
    bargain: "BARGAIN",
    bind: "VINCULAR",
    backup: "BACKUP",
    onTrack: "NO CAMINHO",
    boost: "IMPULSIONAR",
    build: "CONSTRUIR",
    bootBarter: "BOOT/TROCA",
    employees: "Funcionários",
    methodologyTitle: "Metodologia da matriz de nove células",
    methodologySubtitle: "Categorização padronizada de funcionários baseada em cálculos de pontuação de desempenho e prontidão para sucessão.",
    calculationMethod: "Método de cálculo",
    performanceScoreFormula: "Pontuação de desempenho (P)",
    performanceScoreCalculation: "P = 0,6 × Desempenho + 0,4 × Avaliação",
    performanceScoreNote: "As pontuações brutas (-1 a 1,5) são normalizadas para escala 0-100",
    successionReadinessFormula: "Prontidão para sucessão (R)",
    successionReadinessCalculation: "R = 0,5 × Sucessão + 0,3 × Adequação + 0,2 × Pontuação de anos",
    successionReadinessNote: "As pontuações brutas (-1 a 1,5) são normalizadas para escala 0-100",
    yearsScore: "Pontuação de anos",
    yearsScoreCalculation: "Se Anos ≥ 3: 100, senão: (Anos / 3) × 100",
    yearsScoreNote: "Atualmente usa 2 anos por padrão (configurável)",
    cellCategories: "Categorias de células",
    backupDescription: "Alto desempenho, Alta sucessão",
    boostDescription: "Desempenho médio, Alta sucessão",
    bindDescription: "Alta/Média sucessão, Desempenho baixo/médio",
    onTrackDescription: "Desempenho médio/baixo, Sucessão média/baixa",
    buildDescription: "Desempenho médio, Sucessão baixa",
    bargainDescription: "Desempenho baixo, Alta sucessão",
    bootBarterDescription: "Alto desempenho, Sucessão baixa",
    // Talent Score Card specific
    criteria: "Critérios",
    talent: "TALENTO",
    role: "FUNÇÃO",
    remarks: "OBSERVAÇÕES",
    weightage: "Ponderação",
    good: "Bom (8-10)",
    average: "Médio (5-7)",
    poor: "Ruim (1-4)",
    notApplicable: "Não aplicável"
  },

  onboarding: {
    define_kvdr: "Definir KVDRs - Funções Críticas",
    align_talent: "ALINHAR TALENTOS AO QUE IMPULSIONA O NEGÓCIO",
    map_org: "Mapeie sua organização identificando:",
    core_func: "Funções principais e departamentos",
    kvdr: "Funções-Chave de Entrega de Valor (funções que impactam materialmente a estratégia e o crescimento)",
    reporting: "Linhas de reporte e criticidade das funções",
    outcome: "Resultado:",
    tile1: "Um plano organizacional alinhado ao negócio com a visualização de um organograma.",
    tile2: "Um banco de talentos ativo e pesquisável pronto para análise; interno e externo.",
    tile3: "Sinais de talento com redução de viés e visão voltada para o futuro.",
    tile4: "Planos de talentos baseados em dados para contratação, capacitação, sucessão e crescimento.",
    completed: "Concluído",
    start_now: "Começar agora",
    talent_ecosystem: "Construa Seu Ecossistema de Talentos",
    single_source: "FONTE ÚNICA DE VERDADE PARA OS DADOS DAS PESSOAS",
    bring_workforce: "Traga sua força de trabalho para o GetBoarded por meio de:",
    uploading_cvs: "Upload de CVs, Excel ou perfis de função",
    hris: "Conectando seu HRIS (se disponível)",
    enrichment: "Enriquecimento com habilidades, capacidades e aspirações",
    career_trajectories: "Avaliar Trajetórias de Carreira",
    beyond_performance: "ALÉM DE ESTATÍSTICAS DE DESEMPENHO E POTENCIAL",
    configure: "Configure como o talento é avaliado por meio de:",
    gb_trajectories: "Usando os modelos de trajetória do GetBoarded (Fitment, Performance, Sucessão)",
    custom_parameters: "Personalizando parâmetros alinhados ao seu contexto",
    weighing_signals: "Pesando os sinais que importam agora e no futuro",
    talent_plans: "Gerar Planos de Talentos",
    insights_to_execution: "TRANSFORME INSIGHTS EM EXECUÇÃO",
    unlock: "Desbloqueie instantaneamente:",
    role_talent: "Insights de desalinhamento entre função e talento",
    risk_mapping: "Prontidão para sucessão e mapeamento de riscos",
    mobility: "Planos de contratação, mobilidade e desenvolvimento"
},

  // Users
  users: {
    title: "Usuários",
    manageUsers: "Gerenciar usuários",
    // User Recommendations
    talentRecommendations: "Recomendações de talento",
    recommendationsDescription: "Com base na sua avaliação KVDR, aqui estão planos personalizados para a sua organização",
    viewActivePlans: "Ver planos ativos",
    // Recommendation Cards
    fitmentPlan: "Plano de adequação",
    fitmentPlanDescription: "Integração de pessoas em seus papéis.",
    fitmentPlanContent: "Integração de pessoas em seus papéis. Mapeamento do talento certo para os papéis certos com indicadores de adequação",
    developmentPlan: "Plano de desenvolvimento",
    developmentPlanDescription: "Aprendizagem alimentada por IA com ALEX",
    developmentPlanContent: "Criação de planos de aprendizagem com ALEX Caminhos de aprendizagem personalizados para aumentar o valor do talento com habilidades.",
    successionPlanning: "Planejamento de sucessão",
    successionPlanningDescription: "Promover e apoiar o crescimento da carreira",
    successionPlanningContent: "Promover e apoiar o crescimento da carreira Planos de coaching para prontidão de habilidades e tempo para o próximo papel.",
    // Benefits Lists
    roadToRole: "Caminho para seu papel (Jornada)",
    skillProfiling: "Perfilamento de habilidades",
    learningCredits: "Créditos de aprendizagem",
    marketRewards: "Recompensas do mercado",
    customLearningPaths: "Caminhos de aprendizagem personalizados",
    aiAssistedValidation: "Validação assistida por IA",
    progressTracking: "Acompanhamento do progresso com Pontos de Experiência (XPs)",
    interactiveExercises: "Exercícios interativos",
    appraisalIndicators: "Indicadores de avaliação 360°",
    goalSettingMentorship: "Definição de metas e mentoria",
    behaviouralCoaching: "Coaching comportamental e planos",
    managedCareerGuidance: "Orientação de carreira gerenciada",
    // Action Buttons
    onboard: "Integrar",
    activate: "Ativar",
    promote: "Promover",
    // Progress Section
    talentCapabilitySnapshot: "Instantâneo de capacidades de talento",
    lastUpdated: "Última atualização: Hoje",
    refresh: "Atualizar",
    // Score Labels
    industryLeader: "Líder da indústria",
    highPerforming: "Alto desempenho",
    competitive: "Competitivo",
    developing: "Em desenvolvimento",
    foundationBuilding: "Construção de fundamentos",
    // Notifications
    alexActivated: "ALEX ativado",
    alexActivatedText: "Seu assistente de aprendizagem de IA está pronto para ajudar!",
    coachingRequestSent: "Solicitação de coaching enviada",
    coachingRequestSentText: "Um coach entrará em contato em breve!",
    rewardsMarketplace: "Marketplace de recompensas",
    rewardsMarketplaceText: "Explorando recompensas e benefícios disponíveis!"
  },

  // Integrations
  integrations: {
    title: "Integrações",
    manageIntegrations: "Gerenciar integrações"
  },

  // Admins
  admins: {
    title: "Administradores",
    manageAdmins: "Gerenciar administradores"
  },

  //User Dashboard
  userDashboard: {
    expertIn: "Especialista em",
    knownFor: "Conhecido por",
    walletCard: "Carteira",
    activeQuest: "Missão Ativa",
    noDevelopmentPlans: "Nenhum plano de desenvolvimento ativo!",
    activityQueue: "Fila de Atividades",
    talentCard: "Cartão de Talento",
    developmentCharter: "Plano de Desenvolvimento",
    devchar: {
      suggested: "Sugerido",
      fuctionalSkills: "Competências Funcionais",
      softSkills: "Competências Comportamentais",
      news: "Notícias",
      activityQueue: "Fila de Atividades",
      completedItems: "Itens Concluídos"
    },
    sidebar: {
      dashboard: "Painel",
      boards: "Quadros",
      community: "Comunidade",
      wallet: "Carteira",
      notifications: "Notificações",
      myOrganizations: "Minhas Organizações"
    },
    notifications: {
      learningActions: "Ações de Aprendizagem",
      invites: "Administrador Convites",
      manage: "Gerenciar",
      acceptInvitation: "Aceitar Convite",
      noNotifications: "Nenhuma notificação encontrada!"
    },
    boards: {
      activeBoards: "Quadros Ativos",
      archived: "Arquivados",
      noBoards: "Nenhum quadro encontrado!",
      curate: "Organize os seus próprios quadros através da sua organização.",
      goToOrg: "Ir para Organizações"
    },
    wallet: {
      connectWallet: "Conectar Carteira",
      walletHistory: "Histórico da Carteira",
      status: "Status",
      date: "Data",
      amount: "Valor",
      transactions: "Transações",
      type: "Tipo",
      details: "Detalhes",
      done: "Concluído",
      noTransactions: "Nenhum dado disponível"
    },
    profileDropDown: {
      createOrganization: "Criar Organização",
      settings: "Configurações",
      logout: "Sair"
    },
    settings: {
      firstName: "Primeiro Nome",
      lastName: "Sobrenome",
      email: "Email",
      dateOfBirth: "Data de Nascimento",
      gender: "Gênero",
      about: "Sobre",
      saveChanges: "Salvar Alterações",
      account: "Conta"
    }
  }
};



